import React from "react";
import { useWerkveld, WERKVELD_LABELS } from "@/context/WerkveldContext";

// Bovenin elk scherm (desktop + mobiel): Totaal · Actief · Bouwkundig · BMI · Overig + NL · BE · Aanbesteding.
export function WerkveldSchakelaar({ compact = false }) {
  const { werkveld, regio, kanaal, zet, actief } = useWerkveld();
  if (!actief) return null;
  const knop = (act, label, onClick, tid) => (
    <button key={label} onClick={onClick} data-testid={tid}
      className={`px-2 py-0.5 rounded-full text-[11px] font-medium transition-colors ${act ? "bg-[#0D3B66] text-white" : "bg-white/90 text-slate-600 hover:bg-slate-100 border border-slate-200"}`}>{label}</button>
  );
  return (
    <div className={`pointer-events-auto flex flex-wrap items-center gap-1 ${compact ? "" : "px-2 py-1 rounded-full bg-white/95 backdrop-blur-sm border border-border shadow-sm"}`} data-testid="werkveld-schakelaar" title="Werkveld: filtert Vandaag, Relaties, Zaken, Debiteuren, Communicatie en Rapportages">
      {Object.entries(WERKVELD_LABELS).map(([k, l]) => knop(werkveld === k, l, () => zet({ werkveld: k }), `werkveld-${k}`))}
      <span className="w-px h-4 bg-slate-200 mx-0.5" />
      {knop(regio === "NL", "NL", () => zet({ regio: regio === "NL" ? null : "NL" }), "werkveld-regio-nl")}
      {knop(regio === "BE", "BE", () => zet({ regio: regio === "BE" ? null : "BE" }), "werkveld-regio-be")}
      {knop(kanaal === "aanbesteding", "Aanbesteding", () => zet({ kanaal: kanaal === "aanbesteding" ? null : "aanbesteding" }), "werkveld-kanaal-aanbesteding")}
    </div>
  );
}
